
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "55px",
    "height": "55px",
    "viewBox": "0 0 55 55",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "编组 2备份 2"
        }
      ]
    },
    {
      "tag": "defs",
      "children": [
        {
          "tag": "linearGradient",
          "attrsMap": {
            "x1": "50%",
            "y1": "0%",
            "x2": "50%",
            "y2": "100%",
            "id": "linearGradient-1"
          },
          "children": [
            {
              "tag": "stop",
              "attrsMap": {
                "stop-color": "#0265C5",
                "offset": "0%"
              }
            },
            {
              "tag": "stop",
              "attrsMap": {
                "stop-color": "#059EE4",
                "offset": "100%"
              }
            }
          ]
        },
        {
          "tag": "linearGradient",
          "attrsMap": {
            "x1": "50%",
            "y1": "0%",
            "x2": "50%",
            "y2": "100%",
            "id": "linearGradient-2"
          },
          "children": [
            {
              "tag": "stop",
              "attrsMap": {
                "stop-color": "#0265C5",
                "offset": "0%"
              }
            },
            {
              "tag": "stop",
              "attrsMap": {
                "stop-color": "#059EE4",
                "offset": "100%"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "页面-2",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "画板",
            "transform": "translate(-515.000000, -58.000000)"
          },
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "id": "编组-2备份-2",
                "transform": "translate(515.000000, 58.000000)"
              },
              "children": [
                {
                  "tag": "rect",
                  "attrsMap": {
                    "id": "矩形",
                    "fill-opacity": "0",
                    "fill": "#020202",
                    "x": "0",
                    "y": "0",
                    "width": "55",
                    "height": "55"
                  }
                },
                {
                  "tag": "g",
                  "attrsMap": {
                    "id": "编组",
                    "transform": "translate(3.000000, 0.000000)",
                    "fill-rule": "nonzero"
                  },
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M27.8631434,29.0038329 C28.0131434,34.1538329 28.1131434,39.2038329 28.2631434,44.3538329 C28.9131434,44.0038329 29.4631434,43.7038329 30.0131434,43.3538329 C33.8131434,41.2038329 37.5631434,39.0538329 41.3631434,36.9038329 C41.8631434,36.6038329 42.0131434,36.3038329 42.0131434,35.7538329 C41.9631434,33.1038329 42.0131434,30.5038329 42.0131434,27.8538329 C42.0131434,27.6538329 42.0131434,27.4038329 42.0131434,27.1538329 C40.6131434,27.1538329 39.2131434,27.1538329 37.8131434,27.1538329 C37.8131434,27.9038329 37.8131434,28.6538329 37.8131434,29.4538329 C37.8131434,31.0038329 37.8131434,32.5538329 37.8131434,34.1038329 C37.8131434,34.3038329 37.7631434,34.6038329 37.6131434,34.6538329 C35.9631434,35.5538329 34.3131434,36.4538329 32.6131434,37.3538329 C32.6131434,25.8538329 32.6131434,14.4538329 32.6131434,2.95383295 C32.7631434,3.05383295 32.9131434,3.10383295 33.0631434,3.15383295 C34.5131434,4.05383295 35.9631434,4.95383295 37.4131434,5.80383295 C37.7631434,6.00383295 37.8631434,6.25383295 37.8631434,6.60383295 C37.8631434,11.3038329 37.8631434,16.0038329 37.8631434,20.7038329 C37.8631434,20.9038329 37.8631434,21.1538329 37.8631434,21.4038329 C39.4131434,21.4038329 40.9131434,21.4038329 42.4631434,21.4038329 C42.4631434,17.1038329 42.4631434,12.8038329 42.4631434,8.40383295 C44.0631434,9.10383295 45.3631434,9.95383295 46.5631434,11.0038329 C46.9131434,11.3038329 47.2631434,11.6538329 47.5631434,12.0038329 C48.4131434,12.9538329 48.9131434,14.0038329 48.9131434,15.4038329 C48.8631434,22.1038329 48.8631434,28.8038329 48.8131434,35.4538329 C48.8131434,36.7038329 48.8631434,37.9538329 48.7131434,39.2038329 C48.4131434,41.3538329 47.3131434,43.0038329 45.2631434,44.0538329 C38.8131434,47.3538329 32.4131434,50.7038329 25.9631434,54.0538329 C25.1631434,54.5038329 24.3131434,54.8038329 23.3631434,54.7538329 C22.2131434,54.7038329 21.4131434,53.9038329 21.4131434,52.7538329 C21.4131434,46.2538329 21.4131434,39.7538329 21.4131434,33.2538329 C21.4131434,32.7038329 21.5631434,32.3538329 22.0631434,32.1038329 C23.8631434,31.1538329 25.6131434,30.1038329 27.4131434,29.1538329 C27.5131434,29.1538329 27.6631434,29.1038329 27.8631434,29.0038329 Z",
                        "id": "路径",
                        "fill": "url(#linearGradient-1)"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M21.0631434,25.9038329 C20.9131434,20.8038329 20.8131434,15.7538329 20.6631434,10.6538329 C20.5131434,10.7038329 20.3631434,10.7538329 20.2131434,10.8038329 C15.9631434,13.2538329 11.6631434,15.7038329 7.41314339,18.1038329 C7.06314339,18.3038329 6.91314339,18.5038329 6.91314339,18.9538329 C6.91314339,21.7038329 6.91314339,24.4538329 6.91314339,27.2038329 C6.91314339,27.4038329 6.91314339,27.5538329 6.91314339,27.7538329 C8.31314339,27.7538329 9.66314339,27.7538329 11.1131434,27.7538329 C11.1131434,27.4538329 11.1131434,27.1538329 11.1131434,26.9038329 C11.1131434,24.9038329 11.1131434,22.8538329 11.1131434,20.8538329 C11.1131434,20.6538329 11.2131434,20.3038329 11.3631434,20.2038329 C12.9631434,19.3038329 14.6131434,18.4538329 16.3131434,17.5038329 C16.3131434,29.0038329 16.3131434,40.4538329 16.3131434,52.0038329 C16.0631434,51.8538329 15.8631434,51.7538329 15.6631434,51.6538329 C14.2631434,50.8038329 12.9131434,49.9538329 11.5131434,49.1038329 C11.1631434,48.9038329 11.0631434,48.6538329 11.0631434,48.2538329 C11.0631434,43.5538329 11.0631434,38.8538329 11.0631434,34.1538329 C11.0631434,33.9038329 11.0631434,33.7038329 11.0631434,33.4038329 C9.51314339,33.4038329 8.01314339,33.4038329 6.46314339,33.4038329 C6.46314339,37.7538329 6.46314339,42.0538329 6.46314339,46.5038329 C4.11314339,45.3538329 2.06314339,44.0538329 0.613143386,41.9038329 C0.163143386,41.2538329 -0.136856614,40.5038329 0.0631433856,39.6538329 C0.113143386,39.5038329 0.0631433856,39.3538329 0.0631433856,39.2538329 C0.0631433856,32.3038329 0.0631433856,25.3038329 0.0631433856,18.3538329 C0.0631433856,17.0038329 0.0131433856,15.6538329 0.463143386,14.3538329 C1.01314339,12.7538329 1.96314339,11.5538329 3.51314339,10.8038329 C9.16314339,7.95383295 14.7631434,5.00383295 20.4131434,2.10383295 C21.6631434,1.45383295 22.8631434,0.803832949 24.1631434,0.253832949 C25.4131434,-0.246167051 26.4631434,0.00383294929 27.1131434,0.903832949 C27.3131434,1.15383295 27.4131434,1.45383295 27.4131434,1.75383295 C27.4131434,8.45383295 27.4131434,15.1538329 27.4131434,21.9038329 C27.4131434,22.1038329 27.3131434,22.4038329 27.1631434,22.5038329 C25.2131434,23.6538329 23.2131434,24.7538329 21.2131434,25.8538329 C21.2631434,25.9038329 21.1631434,25.9038329 21.0631434,25.9038329 Z",
                        "id": "路径",
                        "fill": "url(#linearGradient-2)"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  